import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styled, { createGlobalStyle } from "styled-components";
import { palette } from "../../../assets/styles/Palette";
import AtomPersonaLoader from "../../Global/components/atoms/AtomPersonaLoader";
import { Button } from "../../../assets/styles/ButtonStyle";
import images from "../../../assets/styles/Images";
import PopupWrap from "../../../assets/styles/Popup";
import Markdown from "markdown-to-jsx";
import {
  ContentsWrap,
  MainContent,
  TabWrapType4,
  TabButtonType4,
  TabWrapType5,
  TabButtonType5,
  TabContent5,
  TabContent5Item,
  BgBoxItem,
  DropzoneStyles,
  Title,
  ListBoxGroup,
  BoxWrap,
  InterviewPopup,
} from "../../../assets/styles/BusinessAnalysisStyle";
import {
  H4,
  H3,
  Sub3,
  Body1,
  Body2,
  Body3,
  Caption1,
  InputText,
} from "../../../assets/styles/Typography";
import {
  FormBox,
  CustomTextarea,
  CustomInput,
  SelectBox,
  SelectBoxItem,
  SelectBoxTitle,
  SelectBoxList,
  RadioButton,
} from "../../../assets/styles/InputStyle";
import "react-dropzone-uploader/dist/styles.css";
import { useDynamicViewport } from "../../../assets/DynamicViewport";
import MoleculeFileUpload from "../components/molecules/MoleculeFileUpload";
import OrganismDesignConceptSelector from "../components/organisms/OrganismDesignConceptSelector";
import MoleculeAnalysisCard from "../components/molecules/MoleculeAnalysisCard";
import MoleculeTemplateCard from "../components/molecules/MoleculeTemplateCard";
import MoleculeCreateDisplayHeader from "../components/molecules/MoleculeCreateDisplayHeader";
import OrganismDisplayViewEduPreview from "../../Global/components/organisms/OrganismDisplayViewEduPreview";
import MoleculeMessageCard from "../../CreatApiContentPage/components/molecules/MoleculeMessageCard";

import {
  IS_LOGGED_IN,
  AUTODISPLAY_SELECTED_DEVICE,
  AUTODISPLAY_DESIGN_GENERATOR,
  AUTODISPLAY_SELECTED_CONTENT,
  CUSTOMER_ID
} from "../../AtomStates";
import { useAtom } from "jotai";
import {
  createEduViewOnServer,
  updateEduViewOnServer,
  AutoDisplayFileAnalysisMultimodalRequest,
  AutoDisplayFileAnalysisRequest,
  AutoDisplayContentGeneratorRequest,
  AutoDisplayDesignGeneratorRequest,
  getUserMemberType,
} from "../../../utils/indexedDB";

const designConceptsData = [
  {
    id: "concept1",
    name: "컨셉1",
    description: "컨셉1",
  },
  {
    id: "concept2",
    name: "컨셉2",
    description: "컨셉2",
  },
  {
    id: "concept3",
    name: "컨셉3",
    description: "컨셉3",
  },
  {
    id: "concept4",
    name: "컨셉4",
    description: "컨셉4",
  },
  {
    id: "concept5",
    name: "컨셉5",
    description: "컨셉5",
  },
  {
    id: "concept6",
    name: "컨셉6",
    description: "컨셉6",
  },
  {
    id: "concept7",
    name: "컨셉7",
    description: "컨셉7",
  },
  {
    id: "concept8",
    name: "컨셉8",
    description: "컨셉8",
  },
  {
    id: "concept9",
    name: "컨셉9",
    description: "컨셉9",
  },
];

const targetAudienceOptions = [
  {
    id: "gradeX",
    name: "1학년 학생",
    icon: (
      <svg
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30.8398 15.0273C31.3401 19.3607 30.5405 28.0273 23.3405 28.0273C16.4616 28.0273 15.1203 20.1165 15.305 15.6318"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M26.8402 10.5273C27.6402 14.1273 31.5069 15.694 33.3402 16.0273C33.6736 11.8607 32.1402 3.52734 23.3402 3.52734C14.5402 3.52734 13.0069 11.8607 13.3402 16.0273C14.5402 16.4273 16.1736 15.194 16.8402 14.5273C21.6402 15.3273 25.5069 12.194 26.8402 10.5273Z"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M15.8398 22.027C13.6307 22.027 11.8398 20.46 11.8398 18.527C11.8398 17.5091 12.3365 16.5927 13.1292 15.9531"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M29.8398 22.0247C32.049 22.0247 33.8398 20.4577 33.8398 18.5247C33.8398 17.3207 33.145 16.2587 32.0871 15.6289"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M18.3398 26.0273V29.0273M18.3398 29.0273L22.8398 33.5273M18.3398 29.0273C17.2919 29.2096 15.9574 29.5388 14.5714 30.0273M22.8398 33.5273L27.3398 29.0273M22.8398 33.5273L18.3398 37.0273L14.5714 30.0273M22.8398 33.5273L27.3398 37.0273L30.8398 29.3964M27.3398 29.0273V27.0273M27.3398 29.0273C28.6279 29.0273 29.7913 29.1606 30.8398 29.3964M14.5714 30.0273C10.8876 31.3257 6.83984 33.749 6.83984 37.5273V42.5273H39.3398V37.5273C38.9165 35.1285 36.6294 30.6986 30.8398 29.3964"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "grade2",
    name: "2학년 학생",
    icon: (
      <svg
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30.8398 15.0273C31.3401 19.3607 30.5405 28.0273 23.3405 28.0273C16.4616 28.0273 15.1203 20.1165 15.305 15.6318"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M26.8402 10.5273C27.6402 14.1273 31.5069 15.694 33.3402 16.0273C33.6736 11.8607 32.1402 3.52734 23.3402 3.52734C14.5402 3.52734 13.0069 11.8607 13.3402 16.0273C14.5402 16.4273 16.1736 15.194 16.8402 14.5273C21.6402 15.3273 25.5069 12.194 26.8402 10.5273Z"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M15.8398 22.027C13.6307 22.027 11.8398 20.46 11.8398 18.527C11.8398 17.5091 12.3365 16.5927 13.1292 15.9531"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M29.8398 22.0247C32.049 22.0247 33.8398 20.4577 33.8398 18.5247C33.8398 17.3207 33.145 16.2587 32.0871 15.6289"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M18.3398 26.0273V29.0273M18.3398 29.0273L22.8398 33.5273M18.3398 29.0273C17.2919 29.2096 15.9574 29.5388 14.5714 30.0273M22.8398 33.5273L27.3398 29.0273M22.8398 33.5273L18.3398 37.0273L14.5714 30.0273M22.8398 33.5273L27.3398 37.0273L30.8398 29.3964M27.3398 29.0273V27.0273M27.3398 29.0273C28.6279 29.0273 29.7913 29.1606 30.8398 29.3964M14.5714 30.0273C10.8876 31.3257 6.83984 33.749 6.83984 37.5273V42.5273H39.3398V37.5273C38.9165 35.1285 36.6294 30.6986 30.8398 29.3964"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "grade3",
    name: "3학년 학생",
    icon: (
      <svg
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30.8398 15.0273C31.3401 19.3607 30.5405 28.0273 23.3405 28.0273C16.4616 28.0273 15.1203 20.1165 15.305 15.6318"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M26.8402 10.5273C27.6402 14.1273 31.5069 15.694 33.3402 16.0273C33.6736 11.8607 32.1402 3.52734 23.3402 3.52734C14.5402 3.52734 13.0069 11.8607 13.3402 16.0273C14.5402 16.4273 16.1736 15.194 16.8402 14.5273C21.6402 15.3273 25.5069 12.194 26.8402 10.5273Z"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M15.8398 22.027C13.6307 22.027 11.8398 20.46 11.8398 18.527C11.8398 17.5091 12.3365 16.5927 13.1292 15.9531"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M29.8398 22.0247C32.049 22.0247 33.8398 20.4577 33.8398 18.5247C33.8398 17.3207 33.145 16.2587 32.0871 15.6289"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M18.3398 26.0273V29.0273M18.3398 29.0273L22.8398 33.5273M18.3398 29.0273C17.2919 29.2096 15.9574 29.5388 14.5714 30.0273M22.8398 33.5273L27.3398 29.0273M22.8398 33.5273L18.3398 37.0273L14.5714 30.0273M22.8398 33.5273L27.3398 37.0273L30.8398 29.3964M27.3398 29.0273V27.0273M27.3398 29.0273C28.6279 29.0273 29.7913 29.1606 30.8398 29.3964M14.5714 30.0273C10.8876 31.3257 6.83984 33.749 6.83984 37.5273V42.5273H39.3398V37.5273C38.9165 35.1285 36.6294 30.6986 30.8398 29.3964"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "allGrades",
    name: "전교생",
    icon: (
      <svg
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30.8398 15.0273C31.3401 19.3607 30.5405 28.0273 23.3405 28.0273C16.4616 28.0273 15.1203 20.1165 15.305 15.6318"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M26.8402 10.5273C27.6402 14.1273 31.5069 15.694 33.3402 16.0273C33.6736 11.8607 32.1402 3.52734 23.3402 3.52734C14.5402 3.52734 13.0069 11.8607 13.3402 16.0273C14.5402 16.4273 16.1736 15.194 16.8402 14.5273C21.6402 15.3273 25.5069 12.194 26.8402 10.5273Z"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M15.8398 22.027C13.6307 22.027 11.8398 20.46 11.8398 18.527C11.8398 17.5091 12.3365 16.5927 13.1292 15.9531"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M29.8398 22.0247C32.049 22.0247 33.8398 20.4577 33.8398 18.5247C33.8398 17.3207 33.145 16.2587 32.0871 15.6289"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M18.3398 26.0273V29.0273M18.3398 29.0273L22.8398 33.5273M18.3398 29.0273C17.2919 29.2096 15.9574 29.5388 14.5714 30.0273M22.8398 33.5273L27.3398 29.0273M22.8398 33.5273L18.3398 37.0273L14.5714 30.0273M22.8398 33.5273L27.3398 37.0273L30.8398 29.3964M27.3398 29.0273V27.0273M27.3398 29.0273C28.6279 29.0273 29.7913 29.1606 30.8398 29.3964M14.5714 30.0273C10.8876 31.3257 6.83984 33.749 6.83984 37.5273V42.5273H39.3398V37.5273C38.9165 35.1285 36.6294 30.6986 30.8398 29.3964"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "teachers",
    name: "교직원",
    icon: (
      <svg
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M32.8389 14.0273C33.3392 18.3607 30.5396 27.0273 23.3396 27.0273C19.0414 27.0273 16.1244 23.9388 14.5857 20.5273C13.6618 18.479 13.2348 16.3143 13.3041 14.6318"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M26.8402 8.52734C27.6402 12.1273 31.5069 14.694 33.3402 15.0273C33.6736 10.8607 32.1402 2.52734 23.3402 2.52734C14.5402 2.52734 13.0069 10.8607 13.3402 15.0273C14.5402 15.4273 16.1736 12.194 16.8402 11.5273C21.6402 12.3273 25.5069 10.194 26.8402 8.52734Z"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M18.3398 25.0273V28.0273M18.3398 28.0273L22.4379 31.0273M18.3398 28.0273C17.701 28.1385 16.9556 28.3042 16.157 28.5273M22.4379 31.0273L27.3398 28.0273M22.4379 31.0273L19.8398 37.5273M22.4379 31.0273L24.8398 37.5273M27.3398 28.0273V26.0273M27.3398 28.0273C28.0431 28.0273 28.7093 28.0671 29.3398 28.1415M19.8398 37.5273L16.157 28.5273M19.8398 37.5273C19.8398 37.5273 21.3095 41.5329 22.4379 41.5273C23.2001 41.5236 24.8398 37.5273 24.8398 37.5273M24.8398 37.5273L29.3398 28.1415M16.157 28.5273C15.6456 28.6702 15.1124 28.8367 14.5714 29.0273C10.8876 30.3257 6.83984 32.749 6.83984 36.5273V41.5273H39.3398V36.5273C38.9165 34.1285 36.6294 29.6986 30.8398 28.3964C30.3638 28.2893 29.8641 28.2034 29.3398 28.1415"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M16.8398 17.0273C16.8398 18.4081 17.9591 19.5273 19.3398 19.5273C20.7206 19.5273 21.8398 18.4081 21.8398 17.0273C21.8398 15.6466 20.7206 14.5273 19.3398 14.5273C17.9591 14.5273 16.8398 15.6466 16.8398 17.0273ZM16.8398 17.0273L13.8398 17.5273"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M29.8398 17.0273C29.8398 18.4081 28.7206 19.5273 27.3398 19.5273C25.9591 19.5273 24.8398 18.4081 24.8398 17.0273M29.8398 17.0273C29.8398 15.6466 28.7206 14.5273 27.3398 14.5273C25.9591 14.5273 24.8398 15.6466 24.8398 17.0273M29.8398 17.0273L32.3398 17.5273M24.8398 17.0273H21.8398"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M12.8398 15.0273C11.183 15.0273 9.83984 16.3705 9.83984 18.0273C9.83984 19.6842 11.183 21.0273 12.8398 21.0273C13.2625 21.0273 13.6647 20.9399 14.0295 20.7822"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M33.0293 15.0273C34.6862 15.0273 36.0293 16.3705 36.0293 18.0273C36.0293 19.6842 34.6862 21.0273 33.0293 21.0273C32.6066 21.0273 32.2044 20.9399 31.8397 20.7822"
          stroke="#666666"
          strokeWidth="2"
        />
      </svg>
    ),
  },
  {
    id: "parents",
    name: "학부모",
    icon: (
      <svg
        width="45"
        height="45"
        viewBox="0 0 45 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.1139 26.0273C15.278 24.1183 14.4465 21.2805 14.2402 19.5273V15.5273C18.6402 15.9273 22.0736 12.0273 23.2402 10.0273C23.6402 13.2273 27.0736 15.0273 28.7402 15.5273V19.5273C28.6371 21.2805 27.9725 24.1183 26.2489 26.0273M17.1139 26.0273C18.2452 27.2037 19.7577 28.0273 21.7402 28.0273C23.7228 28.0273 25.1869 27.2037 26.2489 26.0273M17.1139 26.0273C17.156 27.0273 16.9402 29.3273 15.7402 30.5273M15.7402 30.5273C16.4069 32.0273 18.5402 35.0273 21.7402 35.0273C24.9402 35.0273 26.7402 32.0273 27.2402 30.5273M15.7402 30.5273C14.527 30.5912 12.8489 30.8997 11.2402 31.5935M27.2402 30.5273C26.746 29.694 25.8558 27.6273 26.2489 26.0273M27.2402 30.5273C29.2726 30.5273 30.9173 30.863 32.2402 31.4081M11.2402 31.5935C8.65022 32.7105 6.24023 34.8261 6.24023 38.5273V41.5273H37.2402V38.5273C37.2718 36.5297 36.1904 33.0356 32.2402 31.4081M11.2402 31.5935C10.5736 30.5714 9.54023 27.1273 10.7402 21.5273C12.2402 14.5273 9.24023 11.5273 15.2402 5.52734C15.904 4.86068 18.1333 3.52734 21.7402 3.52734C26.2489 3.52734 30.2402 6.52734 31.2402 10.0273C32.2402 13.5273 31.7402 19.5273 32.7402 21.0273C33.7402 22.5273 34.7402 29.2888 32.2402 31.4081"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "all",
    name: "전체 사용자",
    icon: (
      <svg
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="9.37891"
          y="5.52734"
          width="31.061"
          height="31.061"
          rx="3.40813"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M20.8712 24.3296H17.2572L16.6592 26.0586H14.7482L18.0112 16.9716H20.1302L23.3932 26.0586H21.4692L20.8712 24.3296ZM20.3772 22.8736L19.0642 19.0776L17.7512 22.8736H20.3772ZM26.0428 24.6156H29.0328V26.0586H24.2228V16.9846H26.0428V24.6156ZM31.6196 24.6156H34.6096V26.0586H29.7996V16.9846H31.6196V24.6156Z"
          fill="#666666"
        />
        <path
          d="M31.1535 40.5266H27.4801H20.1332H11.317C8.0709 40.5266 5.43945 37.8951 5.43945 34.6491V25.8328V18.4859V14.8125"
          stroke="#666666"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

const PageCreateEducationContent = () => {
  const navigate = useNavigate();

  const [linkUrl, setLinkUrl] = useState("");
  const [isLoggedIn] = useAtom(IS_LOGGED_IN);
  const [selectedDevice] = useAtom(AUTODISPLAY_SELECTED_DEVICE);
  const [autoDisplayDesignGenerator, setAutoDisplayDesignGenerator] = useAtom(
    AUTODISPLAY_DESIGN_GENERATOR
  );
  // UI 상태 관리
  const [showPopupSave, setShowPopupSave] = useState(false);
  const [showPopupError, setShowPopupError] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [businessDescription, setBusinessDescription] = useState("");
  const [contentTarget, setContentTarget] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingReport, setIsLoadingReport] = useState(false);
  const [showPopupFileSize, setShowPopupFileSize] = useState(false);
  const [toolSteps, setToolSteps] = useState(0);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fileNames, setFileNames] = useState([]);
  const [interviewModeType, setInterviewModeType] = useState("conceptBoard");
  const [isLoadingPreset, setIsLoadingPreset] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [showCreatePersonaPopup, setShowCreatePersonaPopup] = useState(false);
  const [showCreditPopup, setShowCreditPopup] = useState(false);
  const [selectedDesignConcepts, setSelectedDesignConcepts] = useState([]);
  const [dropUpStates, setDropUpStates] = useState({
    customerList: false,
  });
  const [selectBoxStates, setSelectBoxStates] = useState({
    customerList: false,
  });
  const [selectedPurposes, setSelectedPurposes] = useState({
    customerList: "",
  });
  const [isLoadingTemplate, setIsLoadingTemplate] = useState(false);
  const [showTemplateSelection, setShowTemplateSelection] = useState(false);
  const [showPreviewPopup, setShowPreviewPopup] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [showTemplatePreview, setShowTemplatePreview] = useState(false);
  const [templateToPreview, setTemplateToPreview] = useState(null);
  const [autoDisplayFileAnalysis, setAutoDisplayFileAnalysis] = useState(null);
  const [timeStamp, setTimeStamp] = useState(null);
  const [allDesignResponses, setAllDesignResponses] = useState([]); // 모든 디자인 응답 저장
  const [selectedTemplateData, setSelectedTemplateData] = useState(null);
  const [customerId, setCustomerId] = useAtom(CUSTOMER_ID);

  const [
    autoDisplayContentGeneratorMarkdown,
    setAutoDisplayContentGeneratorMarkdown,
  ] = useState([]);
  const [
    autoDisplayContentGeneratorTitle,
    setAutoDisplayContentGeneratorTitle,
  ] = useState([]);
  const [autoDisplayContentGeneratorJson, setAutoDisplayContentGeneratorJson] =
    useState(null);
  const [contentsPurpose, setContentsPurpose] = useState(null);

  const [selectedMessage, setSelectedMessage] = useState(null);
  const [selectedTargetAudience, setSelectedTargetAudience] = useState([]);

  useDynamicViewport("width=1280");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const checkMemberType = async () => {
      const accessToken = sessionStorage.getItem("accessToken");
      const userMemberType = await getUserMemberType(accessToken);
      const lastUrl = sessionStorage.getItem("lastUrl");

      if (
        (lastUrl === "/CreateApiContent" || lastUrl === "/ApiDashBoard") &&
        userMemberType.member_type === 99
      ) {
        navigate("/Admin");
      }

      if (userMemberType.member_type === 11) {
        navigate("/DashBoard");
      } else if (userMemberType.member_type === 12) {
        navigate("/CustomerManage");
      } else if (userMemberType.member_type === 21) {
        navigate("/ApiDashBoard");
      } else if (userMemberType.member_type === 22) {
        navigate("/CustomerManage");
      }
    };

    checkMemberType();
  }, []);

  useEffect(() => {
    if (showToast) {
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = "15px";
    } else {
      document.body.style.overflow = "auto";
      document.body.style.paddingRight = "0";
    }

    return () => {
      document.body.style.overflow = "auto";
      document.body.style.paddingRight = "0";
    };
  }, [showToast]);

  const handleNextStep = (currentStep) => {
    setCompletedSteps([...completedSteps, currentStep]);
    setActiveTab(currentStep + 1);
    setShowPopupError(false);
  };

  const abortControllerRef = useRef(null);

  const handleSubmitConcept = async () => {
    if (autoDisplayFileAnalysis) {
      handleNextStep(1);
      return;
    }
    abortControllerRef.current = new AbortController();
    const signal = abortControllerRef.current.signal;
    const timeStamp = new Date().getTime();
    setTimeStamp(timeStamp);
    // 2초 후 다음 단계로 이동 (API 호출 시뮬레이션)'
    handleNextStep(1);
    setToolSteps(2);
    setIsLoading(true);

    let response;

    try {
      if (interviewModeType === "conceptBoard") {
        // 파일 업로드를 통한 콘텐츠 생성
        const Data = {
          display_id: selectedDevice._id,
          files: uploadedFiles,
          time_stamp: String(timeStamp),
        };

        setFileNames(uploadedFiles.map((file) => file.name));

        let retryCount = 0;
        const maxRetries = 5;
        while (retryCount < maxRetries) {
          try {
            // 콘텐츠 생성을 위한 멀티모달 요청
            response = await AutoDisplayFileAnalysisMultimodalRequest(
              Data,
              isLoggedIn,
              signal
            );

            if (
              response &&
              response.response &&
              response.response.auto_display_file_analysis_multimodal &&
              response.response.auto_display_file_analysis_multimodal.title &&
              response.response.auto_display_file_analysis_multimodal.status &&
              response.response.auto_display_file_analysis_multimodal.detail &&
              response.response.auto_display_file_analysis_multimodal.message
            ) {
              setAutoDisplayFileAnalysis(
                response.response.auto_display_file_analysis_multimodal
              );
              break; // 올바른 응답 형식이면 루프 종료
            }

            retryCount++;
          } catch (error) {
            console.error(`Retry ${retryCount + 1} failed:`, error);
            retryCount++;
            if (retryCount >= maxRetries) throw error;
          }
        }

        if (retryCount >= maxRetries) {
          throw new Error("콘텐츠 분석에 실패했습니다. 다시 시도해주세요.");
        }
      } else {
        // 텍스트만으로 콘텐츠 생성
        const Data = {
          type: "auto_display_file_analysis",
          input_text: businessDescription,
        };

        let retryCount = 0;
        const maxRetries = 5;

        while (retryCount < maxRetries) {
          try {
            response = await AutoDisplayFileAnalysisRequest(Data, isLoggedIn);

            if (
              response &&
              response.response &&
              response.response.auto_display_file_analysis &&
              response.response.auto_display_file_analysis.title &&
              response.response.auto_display_file_analysis.status &&
              response.response.auto_display_file_analysis.detail &&
              response.response.auto_display_file_analysis.message
            ) {
              // API 응답 데이터를 상태에 저장
              setAutoDisplayFileAnalysis(
                response.response.auto_display_file_analysis
              );
              break; // 올바른 응답 형식이면 루프 종료
            }

            retryCount++;
          } catch (error) {
            console.error(`Retry ${retryCount + 1} failed:`, error);
            retryCount++;
            if (retryCount >= maxRetries) throw error;
          }
        }

        if (retryCount >= maxRetries) {
          throw new Error("텍스트 분석에 실패했습니다. 다시 시도해주세요.");
        }
      }
    } catch (error) {
      console.error("콘텐츠 분석 중 오류 발생:", error);
      setShowPopupError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTargetAudienceSelect = (audienceId) => {
    if (completedSteps.includes(2)) return;
    setSelectedTargetAudience((prev) => {
      const grades = ["gradeX", "grade2", "grade3"];
      const allGradesId = "allGrades";
      let newSelected = prev.includes(audienceId)
        ? prev.filter((id) => id !== audienceId)
        : [...prev, audienceId];

      if (grades.includes(audienceId)) {
        // 학년 토글
        if (grades.every(g => newSelected.includes(g))) {
          // 모두 선택됨, 전교생 추가
          if (!newSelected.includes(allGradesId)) newSelected.push(allGradesId);
        } else {
          // 하나라도 없음, 전교생 제거
          newSelected = newSelected.filter(id => id !== allGradesId);
        }
      } else if (audienceId === allGradesId) {
        if (newSelected.includes(allGradesId)) {
          // 전교생 선택, 학년 모두 추가
          grades.forEach(g => { if (!newSelected.includes(g)) newSelected.push(g); });
        } else {
          // 전교생 해제, 학년 모두 제거
          newSelected = newSelected.filter(id => !grades.includes(id));
        }
      }

      const selectedOptions = targetAudienceOptions.filter((option) =>
        newSelected.includes(option.id)
      );
      setContentTarget(selectedOptions.map((opt) => opt.name));
      return newSelected;
    });
  };

  const handleSubmitPurpose = async (isRegenerate = false) => {
    if (autoDisplayContentGeneratorMarkdown.length > 0 && !isRegenerate) {
      handleNextStep(2);
      return;
    }
    handleNextStep(2);
    setIsLoading(true);

    try {
      let data;
      let allResponsesMarkdown = [];
      let allResponsesTitle = [];
      if (
        interviewModeType === "conceptBoard"
      ) {
        // 파일 업로드 모드 - 파일과 함께 전송
        data = {
          type: "ad_education_link_multimodal", // 필수
          // display_id: selectedDevice?._id || "", // 선택된 디스플레이 ID
          upload_files: uploadedFiles.map((file, index) => ({
            id: "file_" + timeStamp + "_" + (index + 1),
            name: file.name,
          })),
          // time_stamp: String(timeStamp),
          display_info: {
            width: selectedDevice?.deviceSpec?.deviceWidth || "1920",
            height: selectedDevice?.deviceSpec?.deviceHeight || "1080",
            resolution: selectedDevice?.deviceSpec?.deviceDPI || "Full HD",
          },
          info_summary: {
            title: autoDisplayFileAnalysis?.title || "",
            source: autoDisplayFileAnalysis?.source || "",
            message: autoDisplayFileAnalysis?.message || "",
            detail: autoDisplayFileAnalysis?.detail || "",
          },
          content_target: (() => {
            const grades = ["gradeX", "grade2", "grade3"];
            const allGradesId = "allGrades";
            // 전교생이 선택되어 있고 학년들이 모두 선택되어 있다면 전교생만 전송
            if (selectedTargetAudience.includes(allGradesId) && grades.every(g => selectedTargetAudience.includes(g))) {
              return ["전교생"];
            }
            // 그렇지 않으면 선택된 옵션들의 이름을 반환
            const selectedOptions = targetAudienceOptions.filter((option) =>
              selectedTargetAudience.includes(option.id)
            );
            return selectedOptions.map((opt) => opt.name);
          })(),
          link_url: linkUrl || ""
        };
      } else if (interviewModeType === "explanation") {
        // 텍스트 입력 모드 - 텍스트만 전송
        data = {
          type: "ad_education_link_generator", // 필수
          input_text: businessDescription,
          display_info: {
            width: selectedDevice?.deviceSpec?.deviceWidth || "1920",
            height: selectedDevice?.deviceSpec?.deviceHeight || "1080",
            resolution: selectedDevice?.deviceSpec?.deviceDPI || "Full HD",
          },
          info_summary: {
            title: autoDisplayFileAnalysis?.title || "",
            source: autoDisplayFileAnalysis?.source || "",
            message: autoDisplayFileAnalysis?.message || "",
            detail: autoDisplayFileAnalysis?.detail || "",
          },
          content_target: (() => {
            const grades = ["gradeX", "grade2", "grade3"];
            const allGradesId = "allGrades";
            // 전교생이 선택되어 있고 학년들이 모두 선택되어 있다면 전교생만 전송
            if (selectedTargetAudience.includes(allGradesId) && grades.every(g => selectedTargetAudience.includes(g))) {
              return ["전교생"];
            }
            // 그렇지 않으면 선택된 옵션들의 이름을 반환
            const selectedOptions = targetAudienceOptions.filter((option) =>
              selectedTargetAudience.includes(option.id)
            );
            return selectedOptions.map((opt) => opt.name);
          })(),
          link_url: linkUrl || ""
        };
      }

      let retryCount = 0;
      const maxRetries = 10;

      while (retryCount < maxRetries) {
        try {
          let response = await AutoDisplayContentGeneratorRequest(
            data,
            isLoggedIn
          );

          if (
            response &&
            response.response &&
            response.response.ad_education_content_generator
          ) {
            allResponsesMarkdown.push(
              response.response.ad_education_content_generator.sections
                .section_first
            );
            allResponsesMarkdown.push(
              response.response.ad_education_content_generator.sections
                .section_second
            );
            allResponsesTitle.push(
              response.response.ad_education_content_generator.title
            );

            // if (selectedDesignConcepts[i] === "모던 게시판형") {
            //   setAutoDisplayContentGeneratorJson(
            //     response.response.ad_education_content_generator_json
            //   );
            // }
            break; // 올바른 응답 형식이면 루프 종료
          }

          retryCount++;
        } catch (error) {
          console.error(`Retry ${retryCount + 1} failed:`, error);
          retryCount++;
          if (retryCount >= maxRetries) throw error;
        }
      }

      if (retryCount >= maxRetries) {
        throw new Error("텍스트 분석에 실패했습니다. 다시 시도해주세요.");
      }

      setAutoDisplayContentGeneratorMarkdown(allResponsesMarkdown);
      setAutoDisplayContentGeneratorTitle(allResponsesTitle);

      console.log(allResponsesMarkdown);
      console.log(autoDisplayContentGeneratorJson);

      setToolSteps(3);
      setCompletedSteps((prev) => [...prev, 3]);
    } catch (error) {
      console.error("콘텐츠 분석 중 오류 발생:", error);
      setShowPopupError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeStatus = ({ meta, file, remove }, status) => {
    const maxSize = 20 * 1024 * 1024; // 20MB
    if (file.size > maxSize && status !== "removed") {
      setShowPopupFileSize(true);
      remove();
      return;
    }

    if (status === "done" || status === "preparing" || status === "uploading") {
      setUploadedFiles((prev) => {
        if (!prev.find((f) => f.name === file.name)) {
          setFileNames((prev) => [...prev, file.name]);
          return [...prev, file];
        }
        return prev;
      });
    } else if (status === "removed") {
      setUploadedFiles((prev) => prev.filter((f) => f.name !== file.name));
      setFileNames((prev) => prev.filter((name) => name !== file.name));
    }

    const size = file.size;
    const sizeStr =
      size > 1024 * 1024
        ? `${(size / (1024 * 1024)).toFixed(1)}MB`
        : `${(size / 1024).toFixed(1)}KB`;

    setTimeout(() => {
      const containers = document.querySelectorAll(".dzu-previewContainer");
      containers.forEach((container) => {
        if (!container.dataset.filename) {
          container.dataset.filename = file.name;
          container.dataset.size = sizeStr;

          if (file.type.startsWith("image/")) {
            if (!container.querySelector(".dzu-previewFileName")) {
              const nameSpan = document.createElement("span");
              nameSpan.className = "dzu-previewFileName";
              nameSpan.textContent = `${file.name}, ${sizeStr}`;

              if (container.firstChild) {
                container.insertBefore(nameSpan, container.firstChild);
              } else {
                container.appendChild(nameSpan);
              }
            }
          }
        }
      });
    }, 0);
  };

  const handleConfirmCredit = async () => {
    setShowCreatePersonaPopup(false);
  };

  const handleDesignConceptSelect = (conceptId) => {
    // 4단계가 완료된 후에는 디자인 선택을 변경할 수 없음
    if (completedSteps.includes(4)) {
      return;
    }
    
    setSelectedDesignConcepts((prev) => {
      if (prev.includes(conceptId)) {
        return [];
      } else {
        return [conceptId];
      }
    });
  };

  const handleDisplayConversion = async () => {
    // 4단계가 완료된 후에는 디스플레이 변환을 다시 실행할 수 없음
    if (completedSteps.includes(4)) {
      return;
    }
    
    // 콘텐츠 제목이 비어있으면 진행하지 않음
    if (!autoDisplayFileAnalysis?.title || autoDisplayFileAnalysis.title.trim() === '') {
      // 에러 메시지 표시 또는 사용자에게 알림
      return;
    }

    setIsLoadingTemplate(true);

    setTimeout(() => {
      setShowTemplateSelection(true);
      setIsLoadingTemplate(false);
    }, 5000);
  };

  const handleTemplatePreview = (template) => {
    setTemplateToPreview(template);
    console.log(
      "미리보기 시점의 selectedPurposes.customerList:",
      selectedPurposes.customerList
    );
    setContentsPurpose(selectedPurposes.customerList); // 미리보기 시점에서 contentsPurpose 설정
    setShowTemplatePreview(true);
  };

  const handleCloseTemplatePreview = () => {
    setShowTemplatePreview(false);
    setTemplateToPreview(null);
  };

  const handleConfirmContent = async () => {
    // 4단계가 이미 완료된 경우 바로 4단계로 이동
    if (completedSteps.includes(4)) {
      setActiveTab(4);
      return;
    }
    
    handleNextStep(3);
    setToolSteps(4);
    // 4단계도 즉시 완료 처리하여 화면실행 탭 활성화
    setTimeout(() => {
      setCompletedSteps(prev => [...prev, 4]);
    }, 100);

    try {
      const createViewId = await createEduViewOnServer(isLoggedIn);

      let finalMarkdown = null;
      let finalTitle = null;
      let finalJson = null;

      finalMarkdown = autoDisplayContentGeneratorMarkdown;
      finalTitle = autoDisplayContentGeneratorTitle[0];

      // 데이터를 조합하여 contentData 객체 생성
      const now = new Date();
      const contentData = {
        viewDevice: {
          _id: selectedDevice?._id || "",
          deviceTitle: selectedDevice?.deviceTitle || "",
          deviceDPI: selectedDevice?.deviceSpec?.deviceDPI || "",
          deviceInch: selectedDevice?.deviceSpec?.deviceInch || "",
          deviceCm: selectedDevice?.deviceSpec?.deviceCm || "",
          deviceWidth: selectedDevice?.deviceSpec?.deviceWidth || "",
          deviceHeight: selectedDevice?.deviceSpec?.deviceHeight || "",
        },
        uploadFileData: uploadedFiles.map((file, index) => ({
          id: "file_" + timeStamp + "_" + (index + 1),
          name: file.name,
        })),
        textData: businessDescription,
        dataAnalysis: {
          title: autoDisplayFileAnalysis?.title || "",
          source: autoDisplayFileAnalysis?.source || "",
          message: autoDisplayFileAnalysis?.message || "",
          detail: autoDisplayFileAnalysis?.detail || "",
        },
        designConcept: selectedDesignConcepts[0],
        contentsType: "link",
        contentsTarget: (() => {
          const grades = ["gradeX", "grade2", "grade3"];
          const allGradesId = "allGrades";
          // 전교생이 선택되어 있고 학년들이 모두 선택되어 있다면 전교생만 저장
          if (selectedTargetAudience.includes(allGradesId) && grades.every(g => selectedTargetAudience.includes(g))) {
            return ["전교생"];
          }
          // 그렇지 않으면 선택된 옵션들의 이름을 반환
          const selectedOptions = targetAudienceOptions.filter((option) =>
            selectedTargetAudience.includes(option.id)
          );
          return selectedOptions.map((opt) => opt.name);
        })(),
        contentGeneratorMarkdown: finalMarkdown,
        contentGeneratorJson: finalJson,
        contentGeneratorTitle: finalTitle,
        createDate: now.toLocaleString("ko-KR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        }),
        createTimestamp: now.getTime(),
        linkUrl: linkUrl || ""
      };
      if (customerId !== "") {
        contentData.customer = customerId;
      }
      setContentsPurpose(selectedPurposes.customerList);
      console.log(
        "selectedPurposes.customerList",
        selectedPurposes.customerList
      );
      await updateEduViewOnServer(createViewId, contentData);

      // setAutoDisplaySelectedContent(createViewId);
      // navigate("/DashBoard");
    } catch (error) {
      console.error("콘텐츠 확인 또는 업데이트 실패:", error);
    }
  };

  useEffect(() => {
    // 새로고침 감지 함수
    const detectRefresh = () => {
      // 현재 URL 확인
      const currentUrl = window.location.href;
      if (currentUrl.toLowerCase().includes("createeducationlink")) {
        // 세션 스토리지에서 마지막 URL 가져오기
        const lastUrl = sessionStorage.getItem("lastUrl");

        // 마지막 URL이 현재 URL과 같으면 새로고침
        if (lastUrl && lastUrl === currentUrl) {
          // if (customerId !== "") {
          //   navigate("/EduboardManage");
          // } else {
            navigate("/EducationDashBoard");
          // }
          return true;
        }

        // 현재 URL 저장
        sessionStorage.setItem("lastUrl", currentUrl);
      }

      return false;
    };

    // F5 키 또는 Ctrl+R 감지
    const handleKeyDown = (event) => {
      if (
        (event.key === "r" && (event.metaKey || event.ctrlKey)) ||
        event.key === "F5"
      ) {
        // F5 키 코드
        event.preventDefault();

        // if (customerId !== "") {
        //   navigate("/EduboardManage");
        // } else {
          navigate("/EducationDashBoard");
        // }
      }
    };

    // 함수 실행
    detectRefresh();

    // 이벤트 리스너 등록
    window.addEventListener("keydown", handleKeyDown);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [navigate]);

  const handleGoBack = async () => {
    try {
      // 현재 저장된 데이터를 가져온다
      let currentData;
      const currentViewId = customerId;

      // currentData = await getViewDetailOnServer(currentViewId, isLoggedIn);

      // console.log("currentData", currentData);

      if (
        currentData &&
        currentData.activateCode &&
        Array.isArray(currentData.activateCode)
      ) {
        // activateCode 배열에서 state와 activeState가 1인 항목들의 updateState를 1로 변경
        const updatedActivateCode = currentData.activateCode.map((item) => {
          if (item.state === 1 && item.activeState === 1) {
            return {
              ...item,
              updateState: 1,
            };
          }
          return item;
        });

        // 기존 데이터 유지하면서 activateCode만 업데이트
        const updateData = {
          ...currentData,
          activateCode: updatedActivateCode,
        };

        // 데이터 타입에 따라 적절한 업데이트 함수 호출
        await updateEduViewOnServer(currentViewId, updateData);

        // console.log("activateCode 업데이트 완료:", updatedActivateCode);
      }

      // 완료 후 페이지 이동
      navigate("/EducationDashBoard?view=contentsList");
    } catch (error) {
      console.error("돌아가기 처리 중 오류 발생:", error);
      // 오류가 발생해도 페이지는 이동
      navigate("/EducationDashBoard?view=contentsList");
    }
  };

  return (
    <>
      <DropzoneStyles />
      <ContentsWrap>
        {/* <OrganismIncNavigation /> */}
        {/* <MoleculeHeader /> */}
        <MoleculeCreateDisplayHeader
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          completedSteps={completedSteps}
          isLoading={isLoading}
          isLoadingReport={isLoadingReport}
          onPreview={handleTemplatePreview}
          onSubmitConcept={handleSubmitConcept}
          onSubmitReport={handleSubmitPurpose}
          onDisplayConversion={handleDisplayConversion}
          hasContentDraft={showTemplateSelection}
          onConfirmContent={handleConfirmContent}
          isLoadingTemplate={isLoadingTemplate}
          // 1단계에서 파일 업로드나 텍스트 입력이 있는지 확인
          canProceedFromStep1={
            activeTab === 1
              ? (interviewModeType === "conceptBoard" &&
                  fileNames &&
                  fileNames.length > 0) ||
                (interviewModeType === "explanation" &&
                  businessDescription &&
                  businessDescription.trim().length > 0)
              : // || (interviewModeType === "article" && selectedMessage)
                true
          }
          // 2단계에서 모든 필수 항목이 선택되었는지 확인
          canProceedFromStep2={
            activeTab === 2
              ? // selectedPurposes.customerList &&
                selectedTargetAudience
              : true
          }
          canProceedFromStep3={
            activeTab === 3 && showTemplateSelection
              ? selectedDesignConcepts.length > 0
              : activeTab === 3
              ? autoDisplayFileAnalysis?.title && 
                autoDisplayFileAnalysis.title.trim() !== ''
              : true
          }
        />

        <MainContent Wide1030>
          <DesignAnalysisWrap>
            {activeTab === 1 && (
              <TabContent5>
                <>
                  <div className="content">
                    <TabContent5Item required>
                      <div style={{ height: "20px" }}></div> {/* 간격용 div */}
                      <H3
                        color="gray800"
                        style={{ textAlign: "left", marginBottom: "12px" }}
                      >
                        AI 콘텐츠 생성을 위한 자료를 업로드해주세요{" "}
                      </H3>
                      <InfoBox>
                        <InfoContent>
                          <Body2
                            color="black"
                            style={{
                              fontWeight: "600",
                              textAlign: "left",
                              fontSize: "20px",
                            }}
                          >
                            {selectedDevice?.deviceTitle}
                          </Body2>
                          <DeviceInfoBox>
                            <Body3 color="gray600">
                              {selectedDevice?.deviceSpec.deviceDPI}
                            </Body3>
                            <Body3 color="gray600">
                              {selectedDevice?.deviceSpec.deviceInch}
                            </Body3>
                            <Body3 color="gray600">
                              {selectedDevice?.deviceSpec.deviceWidthMM}x
                              {selectedDevice?.deviceSpec.deviceHeightMM} (mm)
                            </Body3>
                          </DeviceInfoBox>
                        </InfoContent>
                      </InfoBox>
                    </TabContent5Item>
                  </div>

                  <div className="content">
                    <TabContent5Item required>
                      <InterviewModeSelection style={{ marginBottom: "-5px" }}>
                        <Button
                          Medium
                          Outline
                          style={{
                            backgroundColor:
                              interviewModeType === "conceptBoard"
                                ? "#F7F8FA"
                                : "transparent",
                            borderColor:
                              interviewModeType === "conceptBoard"
                                ? "#E0E4EB"
                                : "#E0E4EB",
                          }}
                          onClick={() => {
                            if (toolSteps >= 1 || isLoadingPreset) return;
                            setInterviewModeType("conceptBoard");
                          }}
                          disabled={toolSteps >= 1 || isLoadingPreset}
                        >
                          <InputText color="gray700">파일 업로드</InputText>
                        </Button>

                        <Button
                          Medium
                          Outline
                          style={{
                            backgroundColor:
                              interviewModeType === "explanation"
                                ? "#F7F8FA"
                                : "transparent",
                            borderColor:
                              interviewModeType === "explanation"
                                ? "#E0E4EB"
                                : "#E0E4EB",
                          }}
                          onClick={() => {
                            if (toolSteps >= 1 || isLoadingPreset) return;
                            setInterviewModeType("explanation");
                            // 텍스트로 작성 모드로 전환할 때 업로드된 파일들 삭제
                            setUploadedFiles([]);
                            setFileNames([]);
                          }}
                          disabled={toolSteps >= 1 || isLoadingPreset}
                        >
                          <InputText color="gray700">텍스트로 작성</InputText>
                        </Button>
                      </InterviewModeSelection>

                      {interviewModeType === "conceptBoard" && (
                        <div className="content" style={{ marginTop: "5px" }}>
                          <MoleculeFileUpload
                            fileNames={fileNames ?? []}
                            handleChangeStatus={handleChangeStatus}
                            toolSteps={toolSteps}
                          />
                        </div>
                      )}
                    </TabContent5Item>

                    {interviewModeType === "explanation" && (
                      <>
                        <FormBox Large style={{ marginTop: "-20px" }}>
                          <CustomTextarea
                            Edit
                            rows={6}
                            placeholder="텍스트를 입력해주세요."
                            value={businessDescription}
                            onChange={(e) =>
                              setBusinessDescription(e.target.value)
                            }
                            status="valid"
                            disabled={toolSteps >= 1}
                          />
                        </FormBox>
                      </>
                    )}
                  </div>
                  {/* 링크 입력 섹션: 파일 업로드/텍스트 작성 영역과 분리하여 아래에 고정 배치 */}
                  <div className="content" style={{ marginTop: "20px" }}>
                    <ContentOptionsSection>
                      <TabContent5Item>
                        <InputGroup>
                          <Label>링크 입력</Label>
                          <FormBox Large>
                            <CustomInput
                              Edit
                              type="url"
                              placeholder="https://example.com"
                              value={linkUrl}
                              onChange={(e) => setLinkUrl(e.target.value)}
                              status="valid"
                              disabled={toolSteps >= 1}
                            />
                          </FormBox>
                        </InputGroup>
                      </TabContent5Item>
                    </ContentOptionsSection>
                  </div>
                </>
              </TabContent5>
            )}

            {activeTab === 2 && completedSteps.includes(1) && (
              <TabContent5>
                {isLoading ? (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      minHeight: "200px",
                      alignItems: "center",
                    }}
                  >
                    <AtomPersonaLoader message="콘텐츠 핵심 내용을 AI로 분석하고 있어요" />
                    <div style={{ height: "520px" }}></div> {/* 간격용 div */}
                  </div>
                ) : (
                  <>
                    <div className="content">
                      <TabContent5Item required>
                        <div style={{ height: "20px" }}></div>{" "}
                        {/* 간격용 div */}
                        <H3
                          color="gray800"
                          style={{ textAlign: "left", marginBottom: "-12px" }}
                        >
                          콘텐츠 주요 내용 및 디스플레이 정보 ​{" "}
                        </H3>
                        <ContentAnalysisSection>
                          <MoleculeAnalysisCard
                            values={{
                              deviceInfo: `${selectedDevice?.deviceTitle} (${selectedDevice?.deviceSpec.deviceInch} / ${selectedDevice?.deviceSpec.deviceWidth}x${selectedDevice?.deviceSpec.deviceHeight} (mm))`,
                              analysisData: autoDisplayFileAnalysis,
                            }}
                          />

                          <ContentOptionsSection>
                            <H3
                              color="gray800"
                              style={{ textAlign: "left", marginTop: "0px" }}
                            >
                              콘텐츠를 전달할 주 대상자를 지정해 주세요{" "}
                            </H3>

                            <TabContent5Item>
                              <TargetAudienceRadioContainer>
                                <TargetAudienceSection>
                                  <SectionTitle>학생</SectionTitle>
                                  <RadioButtonRow>
                                    {targetAudienceOptions
                                      .slice(0, 4)
                                      .map((option) => (
                                        <RadioButtonItem
                                          key={option.id}
                                          selected={
                                            selectedTargetAudience.includes(option.id)
                                          }
                                          onClick={() =>
                                            handleTargetAudienceSelect(option.id)
                                          }
                                        >
                                          <RadioButton
                                            checked={selectedTargetAudience.includes(
                                              option.id
                                            )}
                                            disabled={completedSteps.includes(2)}
                                          />
                                          <RadioButtonLabel>
                                            <RadioButtonContent>
                                              <RadioButtonText
                                                selected={
                                                  selectedTargetAudience.includes(
                                                    option.id
                                                  )
                                                }
                                              >
                                                {option.name}
                                              </RadioButtonText>
                                              <RadioButtonIcon
                                                selected={
                                                  selectedTargetAudience.includes(
                                                    option.id
                                                  )
                                                }
                                              >
                                                {option.icon}
                                              </RadioButtonIcon>
                                            </RadioButtonContent>
                                          </RadioButtonLabel>
                                        </RadioButtonItem>
                                      ))}
                                  </RadioButtonRow>
                                </TargetAudienceSection>
                              </TargetAudienceRadioContainer>
                            </TabContent5Item>
                          </ContentOptionsSection>
                        </ContentAnalysisSection>
                      </TabContent5Item>
                    </div>
                  </>
                )}
              </TabContent5>
            )}

            {activeTab === 3 &&
              (completedSteps.includes(2) || completedSteps.includes(3)) && (
                <TabContent5>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        minHeight: "200px",
                        alignItems: "center",
                      }}
                    >
                      <AtomPersonaLoader
                        message={
                          "AI가 핵심 내용을 추출하여 디스플레이에 적합한 정보로 바꾸고 있어요"
                        }
                      />
                      <div style={{ height: "520px" }}></div> {/* 간격용 div */}
                    </div>
                  ) : (
                    <>
                      <div className="content">
                        <TabContent5Item required>
                          <div style={{ height: "20px" }}></div>{" "}
                          {/* 간격용 div */}
                          <H3
                            color="gray800"
                            style={{ textAlign: "left", marginBottom: "-12px" }}
                          >
                            콘텐츠 주요 내용 및 디스플레이 정보{" "}
                          </H3>
                          <ContentAnalysisSection>
                            <MoleculeAnalysisCard
                              showButton={false}
                              type="template"
                              onButtonClick={() => {
                                setShowPreviewPopup(true);
                              }}
                              values={{
                                deviceInfo: `${selectedDevice?.deviceTitle} (${selectedDevice?.deviceSpec.deviceInch} / ${selectedDevice?.deviceSpec.deviceWidth}x${selectedDevice?.deviceSpec.deviceHeight} (mm))`,
                                analysisData: autoDisplayFileAnalysis,
                                contentPurpose: selectedPurposes.customerList,
                                designConcept: selectedDesignConcepts,
                              }}
                            />

                            {isLoadingTemplate ? (
                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "center",
                                  minHeight: "200px",
                                  alignItems: "center",
                                }}
                              >
                                <AtomPersonaLoader
                                  message={
                                    <>
                                      <span>디자인을 생성 중입니다</span>
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "400",
                                          color: palette.gray500,
                                        }}
                                      >
                                      </span>
                                    </>
                                  }
                                />
                              </div>
                            ) : showTemplateSelection ? (
                              <ContentOptionsSection>
                                <H3
                                  color="gray800"
                                  style={{ textAlign: "left" }}
                                >
                                  아래에서 디자인 테마를 선택해주세요{" "}
                                </H3>
                                <TabContent5Item>
                                  <div
                                    className="title"
                                    style={{
                                      marginBottom: "16px",
                                      marginTop: "-8px",
                                    }}
                                  >
                                  </div>

                                  <OrganismDesignConceptSelector
                                    concepts={designConceptsData}
                                    selectedConcepts={selectedDesignConcepts}
                                    onSelect={handleDesignConceptSelect}
                                    disabled={completedSteps.includes(4)}
                                    titleData={
                                      autoDisplayContentGeneratorTitle[0]
                                    }
                                    markdownData={
                                      autoDisplayContentGeneratorMarkdown
                                    }
                                    onPreview={(concept) => {
                                      console.log("Preview concept:", concept);
                                    }}
                                    contentsType="link"
                                    linkUrl={linkUrl}
                                  />
                                </TabContent5Item>
                              </ContentOptionsSection>
                            ) : (
                              <ContentOptionsSection>
                                <TabContent5Item>
                                  <ContentInputSection>
                                    <H3
                                      color="gray800"
                                      style={{ textAlign: "left" }}
                                    >
                                      콘텐츠 내용과 대상이 잘 맞는지
                                      확인해주세요.​{" "}
                                    </H3>
                                    <InputGroup>
                                      <Label>콘텐츠 제목</Label>
                                      <FormBox Large>
                                        <CustomTextarea
                                          Edit
                                          rows={1}
                                          placeholder="콘텐츠 리스트에서 쉽게 알아볼 수 있도록 작성해주세요"
                                          value={
                                            autoDisplayFileAnalysis?.title || ""
                                          }
                                          onChange={(e) => {
                                            setAutoDisplayFileAnalysis(
                                              (prev) => ({
                                                ...prev,
                                                title: e.target.value,
                                              })
                                            );
                                          }}
                                          status="valid"
                                          maxLength={50}
                                        />
                                      </FormBox>
                                    </InputGroup>

                                    <InputGroup>
                                      <Label>콘텐츠 전달 대상자</Label>
                                      <FormBox Large>
                                        <CustomTextarea
                                          Edit
                                          rows={1}
                                          placeholder="콘텐츠의 방향성과 목적을 작성해주세요"
                                          value={contentTarget}
                                          status="valid"
                                        />
                                      </FormBox>
                                    </InputGroup>
                                  </ContentInputSection>

                                  <div
                                    className="title"
                                    style={{ marginTop: "0px" }}
                                  >
                                    <Body1 color="gray700">
                                      디스플레이 콘텐츠 내용{" "}
                                    </Body1>
                                  </div>

                                  {/* 선택된 디자인 컨셉별로 콘텐츠 박스 생성 */}
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "16px",
                                    }}
                                  >
                                    <ContentConceptBox>
                                      <ContentConceptHeader>
                                        <ConceptTitle></ConceptTitle>
                                        <RegenerateButton
                                          onClick={() =>
                                            handleSubmitPurpose(true)
                                          }
                                          // disabled={regeneratingConcepts.has(
                                          //   concept
                                          // )}
                                        >
                                          <svg
                                            width="13"
                                            height="13"
                                            viewBox="0 0 13 13"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M6.93569 1.10238C6.73825 3.72605 4.44413 4.92239 3.01117 5.27398C2.81081 5.32314 2.66211 5.49758 2.66211 5.70389C2.66211 5.93696 2.85208 6.12328 3.08346 6.15135C5.21146 6.40957 6.69369 8.57558 6.91937 9.99338C6.95039 10.1882 7.10929 10.3482 7.30661 10.3482C7.50393 10.3482 7.66218 10.1869 7.67846 9.99024C7.88338 7.51524 10.2016 6.46546 11.655 6.18303C11.8603 6.14314 12.0161 5.96846 12.0161 5.75933C12.0161 5.53126 11.8294 5.34842 11.6022 5.32934C8.87385 5.10025 7.89142 2.61312 7.69599 1.07933C7.67136 0.886049 7.51151 0.734375 7.31667 0.734375C7.1138 0.734375 6.95091 0.900081 6.93569 1.10238Z"
                                              fill="#226FFF"
                                            />
                                            <path
                                              d="M1.88689 8.77442C1.80044 9.92325 0.795916 10.4471 0.168467 10.601C0.0807353 10.6226 0.015625 10.6989 0.015625 10.7893C0.015625 10.8913 0.098793 10.9729 0.200148 10.9849C1.13514 11.0952 1.78541 12.0247 1.88075 12.6673C1.89343 12.7528 1.96291 12.8229 2.04931 12.8229C2.13571 12.8229 2.205 12.7522 2.21213 12.6661C2.30186 11.5824 3.31694 11.1227 3.95333 10.9991C4.04322 10.9816 4.11144 10.9051 4.11144 10.8136C4.11144 10.7137 4.02971 10.6336 3.9302 10.6253C2.73555 10.525 2.30538 9.43593 2.21981 8.76433C2.20902 8.67969 2.13903 8.61328 2.05371 8.61328C1.96488 8.61328 1.89356 8.68584 1.88689 8.77442Z"
                                              fill="#226FFF"
                                            />
                                          </svg>
                                          <span>다시 생성</span>
                                        </RegenerateButton>
                                      </ContentConceptHeader>
                                      <ContentConceptBody>
                                        <div
                                          className="markdown-body core-value-section"
                                          style={{
                                            color: palette.gray800,
                                            textAlign: "left",
                                            "& h1, & h2, & h3, & h4, & h5, & h6":
                                              {
                                                marginBottom: "0px",
                                                marginTop: "0px",
                                              },
                                            "& h1 + p, & h2 + p, & h3 + p, & h4 + p, & h5 + p, & h6 + p":
                                              {
                                                marginTop: "12px",
                                              },
                                          }}
                                        >
                                          <h1
                                            style={{
                                              fontSize: "40px",
                                              fontWeight: "700",
                                              marginBottom: "20px",
                                            }}
                                          >
                                            {autoDisplayContentGeneratorTitle.length >
                                              0 &&
                                              autoDisplayContentGeneratorTitle[0][0] + " " + autoDisplayContentGeneratorTitle[0][1]
                                              }
                                          </h1>
                                          <Markdown>
                                            {
                                              autoDisplayContentGeneratorMarkdown[0]
                                            }
                                          </Markdown>
                                          <Markdown>
                                            {
                                              autoDisplayContentGeneratorMarkdown[1]
                                            }
                                          </Markdown>
                                        </div>
                                        {/* )} */}
                                      </ContentConceptBody>
                                    </ContentConceptBox>
                                  </div>
                                </TabContent5Item>
                              </ContentOptionsSection>
                            )}
                          </ContentAnalysisSection>
                        </TabContent5Item>
                      </div>
                    </>
                  )}
                </TabContent5>
              )}

            {activeTab === 4 &&
              (completedSteps.includes(3) || completedSteps.includes(4)) && (
                <TabContent5>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        minHeight: "200px",
                        alignItems: "center",
                      }}
                    >
                      <AtomPersonaLoader message="콘텐츠 핵심 내용을 AI로 분석하고 있어요" />
                    </div>
                  ) : (
                    <>
                      <div className="content">
                        <TabContent5Item required>
                          <H3
                            color="gray800"
                            style={{ textAlign: "left", marginBottom: "-20px" }}
                          >
                            확정된 콘텐츠를 화면에 적용해보세요{" "}
                          </H3>
                          <DashedLine />
                          <CompletionContainer>
                            <CompletionIcon>
                              <CheckIcon>
                                <svg
                                  width="28"
                                  height="26"
                                  viewBox="0 0 28 26"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M26.7408 1.07458C27.9568 1.9055 28.269 3.56483 27.438 4.78081L13.7714 24.7808C13.3237 25.4359 12.6076 25.8576 11.8176 25.9314C11.0277 26.0052 10.2458 25.7234 9.68463 25.1625L1.34609 16.8292C0.304367 15.7881 0.30384 14.0997 1.34491 13.0579C2.38599 12.0162 4.07443 12.0157 5.11615 13.0568L11.1813 19.1181L23.0346 1.77179C23.8655 0.555813 25.5249 0.243661 26.7408 1.07458Z"
                                    fill="white"
                                  />
                                </svg>
                              </CheckIcon>
                            </CompletionIcon>

                            <CompletionMessage>
                              <H3
                                color="gray800"
                                style={{
                                  marginBottom: "8px",
                                  marginTop: "16px",
                                }}
                              >
                                콘텐츠 등록이 완료되었습니다
                              </H3>
                            </CompletionMessage>
                          </CompletionContainer>

                          <ContentAnalysisSection>
                            <MoleculeAnalysisCard
                              showButton={false}
                              type="template"
                              onButtonClick={() => {
                                setShowPreviewPopup(true);
                              }}
                              values={{
                                deviceInfo: `${selectedDevice?.deviceTitle} (${selectedDevice?.deviceSpec.deviceInch} / ${selectedDevice?.deviceSpec.deviceWidth}x${selectedDevice?.deviceSpec.deviceHeight} (mm))`,
                                analysisData: autoDisplayFileAnalysis,
                                contentPurpose: selectedPurposes.customerList,
                                designConcept:
                                  selectedDesignConcepts || "concept1",
                              }}
                            />
                          </ContentAnalysisSection>
                          <DashedLine />
                        </TabContent5Item>
                      </div>

                      <ButtonContainer>
                        <Button
                          Primary
                          Large
                          Fill
                          style={{
                            width: "120px",
                            height: "40px",
                            fontSize: "16px",
                          }}
                          onClick={handleGoBack}
                        >
                          돌아가기
                        </Button>
                      </ButtonContainer>
                    </>
                  )}
                </TabContent5>
              )}
          </DesignAnalysisWrap>
        </MainContent>
      </ContentsWrap>

      {showTemplatePreview && (
        <OrganismDisplayViewEduPreview
          template={templateToPreview}
          onClose={handleCloseTemplatePreview}
          title={autoDisplayFileAnalysis?.title}
          displayWidth={selectedDevice?.deviceSpec?.deviceWidth || "1080"}
          displayHeight={selectedDevice?.deviceSpec?.deviceHeight || "1920"}
          jsonData={autoDisplayContentGeneratorJson}
          contentsPurpose={contentsPurpose}
          contentsDesignConcept={selectedDesignConcepts}
          markdownData={
            autoDisplayContentGeneratorMarkdown[
              selectedDesignConcepts.findIndex(
                (c) => c === templateToPreview.category
              )
            ]
          }
          titleData={
            autoDisplayContentGeneratorTitle[
              selectedDesignConcepts.findIndex(
                (c) => c === templateToPreview.category
              )
            ]
          }
          contentsType="link"
          linkUrl={linkUrl}
        />
      )}

      {showPopupError && (
        <PopupWrap
          Warning
          title="다시 입력해 주세요."
          message="현재 입력하신 정보는 목적을 생성할 수 없습니다."
          buttonType="Outline"
          confirmText="확인"
          isModal={false}
          onConfirm={() => window.location.reload()}
        />
      )}

      {showPopupFileSize && (
        <PopupWrap
          Warning
          title="파일 크기 초과"
          message="파일 크기는 20MB를 초과할 수 없습니다."
          buttonType="Outline"
          confirmText="확인"
          isModal={false}
          onConfirm={() => setShowPopupFileSize(false)}
        />
      )}

      {showPopupSave && (
        <PopupWrap
          Check
          title="리포트가 저장되었습니다."
          message="저장된 리포트는 '보관함'을 확인해주세요"
          buttonType="Outline"
          closeText="보관함 바로가기"
          confirmText="리포트 계속 확인"
          isModal={false}
          onCancel={() => setShowPopupSave(false)}
          onConfirm={() => setShowPopupSave(false)}
        />
      )}

      {showCreatePersonaPopup && (
        <PopupWrap
          Check
          title="NPS 분석을 시작합니다"
          message="페르소나 기반 NPS 분석을 진행하시겠습니까?"
          buttonType="Outline"
          closeText="취소"
          confirmText="시작하기"
          isModal={false}
          onCancel={() => {
            setShowCreatePersonaPopup(false);
            navigate("/Tool");
          }}
          onConfirm={handleConfirmCredit}
        />
      )}

      {showCreditPopup && (
        <PopupWrap
          Warning
          title="서비스 이용 안내"
          message="해당 서비스를 이용하시겠습니까?"
          buttonType="Outline"
          closeText="확인"
          isModal={false}
          onCancel={() => {
            setShowCreditPopup(false);
            navigate("/Tool");
          }}
          onConfirm={() => {
            setShowCreditPopup(false);
            navigate("/Tool");
          }}
        />
      )}

      {showPreviewPopup && (
        <>
          <StyledInterviewPopup>
            <div
              style={{
                maxWidth: "700px",
                width: "100%",
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                gap: "20px",
                padding: "32px 32px",
                borderRadius: "15px",
                background: "#FFFFFF",
                boxShadow: "4px 4px 30px rgba(0, 0, 0, 0.15)",
              }}
            >
              <div className="header">
                <H4
                  style={{
                    fontSize: "16px",
                    marginBottom: "16px",
                  }}
                >
                  디스플레이 콘텐츠 자세히 보기
                  <span
                    className="close"
                    onClick={() => setShowPreviewPopup(false)}
                  />
                </H4>
              </div>

              <div className="content" style={{ textAlign: "left" }}>
                <div style={{ marginBottom: "12px" }}>
                  <Body2
                    color="gray700"
                    style={{ fontWeight: "400", textAlign: "left" }}
                  >
                    콘텐츠 목적
                  </Body2>
                  <DetailBox>
                    <Body2
                      color="gray800"
                      style={{ fontWeight: "400", textAlign: "left" }}
                    >
                      {selectedPurposes.customerList}
                    </Body2>
                  </DetailBox>
                </div>
                <div>
                  <Body2
                    color="gray700"
                    style={{ fontWeight: "400", textAlign: "left" }}
                  >
                    콘텐츠 내용
                  </Body2>
                  <DetailContentBox>
                    <Body3
                      color="gray600"
                      style={{ fontWeight: "400", textAlign: "left" }}
                    >
                      {autoDisplayFileAnalysis?.detail}
                    </Body3>
                  </DetailContentBox>
                </div>
              </div>
            </div>
          </StyledInterviewPopup>
        </>
      )}
    </>
  );
};

export default PageCreateEducationContent;

const DesignAnalysisWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 100px;
  margin-top: 60px;
`;

const InterviewModeSelection = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: flex-start;
  margin-bottom: 48px;

  button {
    flex: 0 0 auto;
    max-width: 200px;
  }

  .button-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 20px;
  }
`;

export const CheckCircle = styled.input`
  appearance: none;
  display: block !important;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;

  background-image: ${(props) =>
    props.checked
      ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='12' fill='%23226FFF'/%3E%3Cpath d='M6.76562 12.4155L9.9908 15.6365L17.2338 8.36426' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`
      : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='11.5' stroke='%23E0E4EB'/%3E%3C/svg%3E")`};
  transition: background-image 0.3s ease-in-out;

  + label {
    cursor: pointer;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;

    + label {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
`;

const StyledInterviewPopup = styled(InterviewPopup)`
  .markdown-body {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-top: 0px;
      margin-bottom: 12px;
      color: ${palette.gray800};
      font-weight: 600;
    }
    p,
    li,
    span {
      line-height: 1.55;
    }
    p {
      margin-bottom: 8px;
    }
    h1 {
      font-size: 24px;
    }
    h2 {
      font-size: 20px;
    }
    h3 {
      font-size: 18px;
    }
  }
  .core-value-section h2:nth-of-type(4) ~ p:last-of-type {
    margin-bottom: 12px !important;
  }

  h2:nth-of-type(4) ~ h2:nth-of-type(5) {
    margin-top: 20px;
  }
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px;
  border: 1px solid ${palette.outlineGray};
  border-radius: 10px;
  // background: ${palette.gray100};
  width: 100%;
`;

const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const DeviceInfoBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  // padding: 12px 16px;
  border-radius: 6px;
  // margin-top: 8px;

  > * {
    white-space: nowrap;
  }

  > *:not(:last-child)::after {
    content: "|";
    margin-left: 8px;
    color: #e0e4eb;
  }
  // > *:not(:last-child):not(:nth-last-child(2))::after {
  //   content: "|";
  //   margin-left: 8px;
  //   color: #e0e4eb;
  // }
`;

const ContentAnalysisSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin: 24px 0 0px 0;
  width: 100%;
`;

const ContentOptionsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const FestivalInfoBox = styled.div`
  border: 1px solid ${palette.outlineGray};
  border-radius: 16px;
  padding: 24px;
  margin-top: 16px;
  min-width: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

const CompletionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: 32px auto;
  text-align: center;
  width: 100%;
`;

const CompletionIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${palette.primary};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CheckIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const CompletionMessage = styled.div`
  text-align: center;
  max-width: 400px;
`;

const DashedLine = styled.div`
  width: 100%;
  height: 1px;
  border-top: 2px solid ${palette.gray300};
  margin: 0px;
  margin-top: 32px;
  margin-bottom: 36px;
`;

const DetailBox = styled.div`
  background: ${palette.gray100};
  border-radius: 8px;
  padding: 12px 16px;
`;

const DetailContentBox = styled.div`
  background: ${palette.gray100};
  border-radius: 8px;
  padding: 12px 16px;
`;

const ContentConceptBox = styled.div`
  border: 1px solid ${palette.outlineGray};
  border-radius: 10px;
  min-width: 820px;
  overflow: hidden;
`;

const ContentConceptHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px 8px 20px;
  background: #f2f6ff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: none;
`;

const ConceptTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #090f15;
  line-height: 24px;
  font-family: Pretendard;
`;

const RegenerateButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  background: transparent;
  color: #226fff;
  border: none;
  cursor: pointer;
  font-size: 15px;
  font-weight: 400;
  font-family: Pretendard;
  line-height: 22.5px;

  span {
    color: #226fff;
  }

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ContentConceptBody = styled.div`
  padding: 20px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  .markdown-body {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-top: 0px;
      margin-bottom: 12px;
      color: #090f15;
      font-weight: 400;
      font-family: Pretendard;
    }
    p,
    li,
    span {
      line-height: 1.55;
      color: #090f15;
      font-size: 19px;
      font-weight: 400;
      font-family: Pretendard;
      line-height: 28.5px;
    }
    p {
      margin-bottom: 8px;
    }
    h1 {
      font-size: 24px;
    }
    h2 {
      font-size: 20px;
    }
    h3 {
      font-size: 18px;
    }
  }
  .core-value-section h2:nth-of-type(4) ~ p:last-of-type {
    margin-bottom: 12px !important;
  }

  h2:nth-of-type(4) ~ h2:nth-of-type(5) {
    margin-top: 20px;
  }
`;

const TargetAudienceRadioContainer = styled.div`
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
  display: flex;
`;

const TargetAudienceSection = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px;
  display: flex;
`;

const SectionTitle = styled.span`
  color: #666666;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 1.55;
  word-wrap: break-word;
  text-align: inherit;
`;

const RadioButtonRow = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  gap: 13px;
  display: flex;
  flex-wrap: wrap;
`;

const RadioButtonItem = styled.div`
  width: 195.25px;
  padding: 12px;
  background: ${(props) =>
    props.selected ? "rgba(34, 111, 255, 0.04)" : "white"};
  border-radius: 10px;
  border: 1px solid ${(props) => (props.selected ? "#226FFF" : "#E0E4EB")};
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  display: flex;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) =>
      props.selected ? "rgba(34, 111, 255, 0.04)" : "#F7F8FA"};
    border-color: ${(props) => (props.selected ? "#226FFF" : "#BCC4D0")};
  }
`;

const RadioButtonLabel = styled.label`
  cursor: pointer;
  flex: 1;
`;

const RadioButtonContent = styled.div`
  justify-content: center;
  align-items: center;
  gap: 12px;
  display: flex;
`;

const RadioButtonText = styled.span`
  color: ${(props) => (props.selected ? "#226FFF" : "#666666")};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 600;
  line-height: 24.8px;
  word-wrap: break-word;
`;

const RadioButtonIcon = styled.div`
  width: 44px;
  height: 44px;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 36px;
    height: 36px;

    path {
      stroke: ${(props) => (props.selected ? "#226FFF" : "#DEDEDE")};
    }
    rect {
      stroke: ${(props) => (props.selected ? "#226FFF" : "#DEDEDE")};
    }
  }
`;
const Label = styled.label`
  color: #666666;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 1.55;
  text-align: left;
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  width: 100%;
`;

const ContentInputSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 0px;
  margin-bottom: 24px;
  width: 100%;
`;